export const load = () => ({
	title:
		'Home Depot’s Soundproof Windows & Products — and a Better Alternative',
	showTitle: true,
});
